import {Component} from 'nuxt-property-decorator';
import RoutingUtil from '@/classes/view/routing-util';
import APage from '@/classes/page/a-page';
import {appModule} from '@/store/app';
import {managerLoaderModule} from '@/store/manager/loader';

@Component({
	layout: 'teaser',
    components: {
    }
})
export default class Index extends APage {

    public title: string;

    public initialSlide: number = 0;
    public visualOn: boolean = false;
	public waitLoadingInterval: any;


    ///////// 全ページ共通 ////////////////////////////////////////////
    public mypagetype: string = 'official-home';
    public mydivider: string = 'full';


    // ヘッダタグの構成要素
    public head() {
        return {
            title: 'できること｜THOUGHT ブランディングツール'
        };
    }

    ///////// 全ページ共通 ////////////////////////////////////////////
    public transition(to: any, from: any) {
        return RoutingUtil.transition(to, from);
    }

    public created() {
        ///////// 全ページ共通 ////////////////////////////////////////////
        this.setPagetype(appModule, this.mypagetype, this.mydivider);
    }

    public mounted() {

        //Loadingが終わったら再生する
        this.waitLoadingInterval = setInterval(() => {
            if (!this.isLoading) {
                this.visualOn = true;
                clearInterval(this.waitLoadingInterval);
            }
        }, 50);
    }


	// Destoryed ////////////////////////////////////////////////////////////////////
    public destoryed(){
        clearInterval(this.waitLoadingInterval);
    }

	// Computed ////////////////////////////////////////////////////////////////////
	public get isLoading(): boolean {
    	return managerLoaderModule.loading;
	}

	public get deviceSize(): any {
    	return appModule.deviceSize;
	}

}
